/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './ExternalModal.scss';

import { number, func, string } from 'prop-types';
import React from 'react';

import BaseModal from 'components/shared/Modal/BaseModal';

const ExternalModal = ({ close, frameUrl, isOpen, children, title }) => {
  return (
    <BaseModal
      close={close}
      containerClassName="external-modal-container"
      title={null}
      label="external-overlay-modal"
      disableClickOff
      hideAnchor
      isOpen={isOpen}>
      <div className="external-modal-content">
        <iframe title={title} src={frameUrl} frameBorder={0} />
        <div>{children}</div>
      </div>
    </BaseModal>
  );
};

ExternalModal.propTypes = {
  frameUrl: string.isRequired,
  close: func.isRequired,
  width: number,
  height: number
};

export default ExternalModal;
